<app-template>

    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">
        <div class="principal-section">
            <div class="img-principal2"></div>
            <div class="side image-background">
                <div class="data">
                    <div class="title">
                        <p>¡Listo! Recibimos correctamente tus datos.
                            <br><br><span>Nos pondremos en contacto contigo, gracias.</span></p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">

        <div class="box-container">

            <div class="fad-movil">
                <img src="assets/images/m/fadangel.png">
            </div>

            <div class="content-general">
                <p class="title-secondary"><span>¡Listo!</span> Recibimos<br><span>correctamente tus<br>datos.</span></p>
                <p class="title-secondary">Nos pondremos en<br>contacto contigo, <br><span>gracias.</span></p>
            </div>

        </div>

    </div>

</app-template>
